import { Icon, theme } from '@salecycle/ui-component-library';
import React from 'react';
import styled from 'styled-components';

interface IProps {
  onClick?: (e?: React.MouseEvent) => void;
}

const CellElement = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.vars.newColor.darkGS2};
  cursor: pointer;
`;

export const EditButton: React.FC<IProps> = (props: IProps) => {
  return (
    <CellElement data-testid="EditButton" onClick={props.onClick}>
      <Icon icon={'cog'} />
    </CellElement>
  );
};
